import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { faSync, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { FC } from 'react';
import './notify.scss';

type Props = {
    isVisible: boolean,
    displayRightSideIcon?: boolean,
    displayLeftSideIcon?: boolean,
    message: string,
    onRightSideIconClick?: () => void,
    onLeftSideIconClick?: () => void,
    backgroundColor?: string,
    leftSideIcon?: IconDefinition,
    rightSideIcon?: IconDefinition,
    rightSideIconColor?: string,
    leftSideIconColor?: string,
}

export const Notify: FC<Props> = ({ isVisible, message, onRightSideIconClick, onLeftSideIconClick, displayRightSideIcon = true, displayLeftSideIcon = true, backgroundColor = '#f07510af', leftSideIcon = faTimes, leftSideIconColor = '#080808af', rightSideIconColor = '#080808af', rightSideIcon = faSync }) => {
    return (
        <Toolbar visible={isVisible} className={'error-toolbar'} style={{backgroundColor: backgroundColor}} elementAttr={{ class: `error-toolbar` }}>
            {displayLeftSideIcon &&
                <Item location={'before'} cssClass={'cancel-icon'}>
                    <FontAwesomeIcon icon={leftSideIcon as IconProp} size={'lg'} color={leftSideIconColor} onClick={onLeftSideIconClick} />
                </Item>
            }
            <Item location={'center'} cssClass={'error-title'} text={message} />
            {displayRightSideIcon && 
                <Item location={'after'} cssClass='retry-icon'>
                    <FontAwesomeIcon icon={rightSideIcon as IconProp} size={'lg'} color={rightSideIconColor} onClick={onRightSideIconClick} />
                </Item>
            }
        </Toolbar>
    );
};
